'use client'

import Link from "next/link";
import {usePathname} from "next/navigation";
import {LifeBuoy} from "lucide-react";

const HIDDEN_PATHS = ["/login", "/sign-up", "/activate", "/support"];

export function SupportLauncher() {
    const pathname = usePathname();
    if (HIDDEN_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))) {
        return null;
    }

    return (
        <>
            <Link className="dp-support-launcher" href="/support" aria-label="DevPlaner Support öffnen">
                <LifeBuoy aria-hidden="true" />
                <span>Support</span>
            </Link>
            <style jsx global>{`
                .dp-support-launcher {
                    position: fixed;
                    right: 24px;
                    bottom: 24px;
                    z-index: 45;
                    height: 46px;
                    display: inline-flex;
                    align-items: center;
                    gap: 9px;
                    padding: 0 16px;
                    border: 1px solid rgba(96, 165, 250, 0.22);
                    border-radius: 14px;
                    background: rgba(10, 20, 34, 0.92);
                    box-shadow: 0 18px 50px rgba(0, 0, 0, 0.28);
                    color: #dbeafe;
                    font-size: 13px;
                    font-weight: 620;
                    text-decoration: none;
                    backdrop-filter: blur(16px);
                    transition: border-color 160ms ease, background 160ms ease, transform 160ms ease;
                }

                .dp-support-launcher:hover {
                    transform: translateY(-2px);
                    border-color: rgba(96, 165, 250, 0.48);
                    background: rgba(15, 34, 59, 0.97);
                }

                .dp-support-launcher svg {
                    width: 17px;
                    height: 17px;
                    color: #60a5fa;
                }

                @media (max-width: 640px) {
                    .dp-support-launcher {
                        right: 16px;
                        bottom: 16px;
                        width: 46px;
                        padding: 0;
                        justify-content: center;
                        border-radius: 50%;
                    }

                    .dp-support-launcher span {
                        display: none;
                    }
                }
            `}</style>
        </>
    );
}
